import { useSurvey } from './hooks/useSurvey';
import { questionSteps } from '@/mocks/surveyData';
import FixedHeader from './components/FixedHeader';
import IntroScreen from './components/IntroScreen';
import QuestionScreen from './components/QuestionScreen';
import ConsentScreen from './components/ConsentScreen';
import CompletionScreen from './components/CompletionScreen';
import NavigationButtons from './components/NavigationButtons';

export default function SurveyPage() {
  const survey = useSurvey();
  const { currentStep, progress } = survey;

  let sectionLabel = '';
  if (currentStep >= 1 && currentStep <= 14) {
    const stepData = questionSteps[currentStep - 1];
    sectionLabel = `섹션 ${stepData.sectionNumber} / 6 · ${stepData.sectionName}`;
  } else if (currentStep === 15) {
    sectionLabel = '약관 동의';
  }

  const displayProgress = currentStep === 16 ? 100 : progress;

  const renderContent = () => {
    if (currentStep === 0) {
      return <IntroScreen />;
    }
    if (currentStep >= 1 && currentStep <= 14) {
      const stepData = questionSteps[currentStep - 1];
      return <QuestionScreen questionIds={stepData.questionIds} survey={survey} />;
    }
    if (currentStep === 15) {
      return <ConsentScreen survey={survey} />;
    }
    if (currentStep === 16) {
      return <CompletionScreen />;
    }
    return null;
  };

  return (
    <div className="min-h-screen bg-cream flex justify-center">
      <div className="w-full max-w-[430px] min-h-screen bg-cream flex flex-col relative shadow-sm">
        <FixedHeader progress={displayProgress} sectionLabel={sectionLabel} />

        <main className="flex-1 overflow-y-auto px-6 pt-6 pb-28">
          {renderContent()}
        </main>

        <footer className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] bg-cream border-t border-border-color py-4 z-10">
          <NavigationButtons survey={survey} />
        </footer>
      </div>
    </div>
  );
}